import React, { memo, useState } from 'react';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import { formatNumber } from '../../../../../../logic/otherUtilities/formatting/formatNumber';
import VoxelLoadingSpinner from '../../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../../voxel/DataTable/VoxelDataTableCell';
import { VoxelPopover } from '../../../../../voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../../../voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../../../voxel/Popover/VoxelPopoverTrigger';
import VolumeLargeSvg from './VolumeLargeSvg';
import VolumeSmallSvg from './VolumeSmallSvg';

export interface TableCellVolumeProps {
  keyword: ProjectKeywordGq;
  endMonth?: string;
  startMonth?: string;
  longMonthDisabled: boolean;
}

const TableCellVolume: React.FC<TableCellVolumeProps> = memo(
  ({ keyword, longMonthDisabled, endMonth, startMonth }) => {
    const [popoverOpen, setPopoverOpen] = useState(false);
    return (
      <VoxelDataTableCell align="right" type="number">
        {/* Cell content */}
        {keyword.fetchingNewVolume ? (
          <div className="flex flex-row justify-end">
            <VoxelLoadingSpinner />
          </div>
        ) : (
          <div className="flex flex-row justify-end items-center gap-3 flex-nowrap">
            <div className="font-medium text-voxel-gray-700">{formatNumber(keyword.volume)}</div>
            <VoxelPopover
              placement="bottom"
              enableArrow
              offsetPx={14}
              open={popoverOpen}
              onOpenChange={setPopoverOpen}
            >
              <VoxelPopoverTrigger>
                <div
                  className={`mb-0 rounded-[1px] 
                  outline outline-1 outline-offset-2 outline-voxel-gray-200 
                  hover:outline-voxel-gray-500 
                  ${popoverOpen ? 'outline-voxel-gray-500' : 'outline-transparent'}
                `}
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  onMouseUp={(e) => e.stopPropagation()}
                >
                  <VolumeSmallSvg keyword={keyword} endMonth={endMonth} />
                </div>
              </VoxelPopoverTrigger>
              <VoxelPopoverContent
                paddingClass="p-6"
                shadowClass="drop-shadow-md"
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <VolumeLargeSvg
                  keyword={keyword}
                  longMonthDisabled={longMonthDisabled}
                  endMonth={endMonth}
                  startMonth={startMonth}
                />
              </VoxelPopoverContent>
            </VoxelPopover>
          </div>
        )}
      </VoxelDataTableCell>
    );
  }
);

export default TableCellVolume;
